import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createPlaqueReportSlice = (set, get) => ({
    plaqueReoprt: {
        loading: false,
        data: [],
        singlePlaqueReport: {
            data: null,
            loading: false
        }
    },
    getPlaquesReport: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;

        set(state => ({ plaqueReoprt: { ...state.plaqueReoprt, loading: true, singlePlaqueReport: { data: null, loading: false } } }));

        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/Plaque-Inquiry-Report/${params.fromDate}/${params.toDate}`,
                headers: { token }
            });

            set(() => ({ plaqueReoprt: { loading: false, data: resp.data, singlePlaqueReport: { data: null, loading: false } } }));
        } catch (error) {
            set(() => ({ plaqueReoprt: { loading: false, data: [], singlePlaqueReport: { data: null, loading: false } } }));
        }
    },


    getPlaqueReport: async (inquiryId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;

        set(state => ({ plaqueReoprt: { ...state.plaqueReoprt, singlePlaqueReport: { data: null, loading: true } } }));

        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/Plaque-Inquiry-Report/${inquiryId}/Detail`,
                headers: { token }
            });

            set(state => ({ plaqueReoprt: { ...state.plaqueReoprt, singlePlaqueReport: { data: resp.data, loading: false } } }));
        } catch (error) {
            set(state => ({ plaqueReoprt: { ...state.plaqueReoprt, singlePlaqueReport: { data: null, loading: false } } }));
        }
    },


});
